<mat-card class="mat-card-user-detail">
  <mat-card-header>
    <mat-card-title>{{ 'label.index' | translate }}</mat-card-title>
    <mat-card-subtitle *ngIf="!data?.id">{{ 'label.creation' | translate }}</mat-card-subtitle>
    <mat-card-subtitle *ngIf="data?.id">{{ 'label.edition' | translate }}</mat-card-subtitle>
  </mat-card-header>
  <form [formGroup]="indexForm" (ngSubmit)="onSubmit()">
    <mat-card-content>
      <div class="content-row">
        <label class="content-row-label">{{ 'label.base-index' | translate }} {{ masterIndex?.year }}</label>
        <div class="content-row-input" style="display: flex;justify-content: flex-end;">
          <span>{{ masterIndex?.value }}</span>
        </div>
      </div>
      <div class="content-row">
        <label class="content-row-label">{{ 'label.year' | translate}}</label>
        <mat-form-field class="content-row-input">
          <input matInput formControlName="year" type="number" autocomplete="off">
        </mat-form-field>
      </div>
      <div class="content-row">
        <label class="content-row-label">{{ 'label.value' | translate }}</label>
        <mat-form-field class="content-row-input">
          <input matInput formControlName="value" type="number" autocomplete="off">
        </mat-form-field>
      </div>

      <div class="content-row">
        <label class="content-row-label">{{ 'label.index-coef' | translate }}</label>
        <div class="content-row-input" style="display: flex;justify-content: flex-end;"> 
          <span>{{calculIndex | number :'0.3' :'fr' }}</span>
        </div>
      </div>

    </mat-card-content>
    <mat-card-actions class="report-error-card-action">
      <button mat-raised-button color="warn" type="button" (click)="onCancel()">
        <mat-icon>clear</mat-icon> {{ 'button.cancel' | translate }}
      </button>
      <button mat-raised-button color="primary" [disabled]="indexForm.invalid">
        <mat-icon>save</mat-icon> {{ 'button.save' | translate }}
      </button>
    </mat-card-actions>
  </form>
</mat-card>